import {FontStyle} from './FontStyle';

export class CellStyle {
font: FontStyle;
foregroundColor: string;
}

